import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'cl-ui-configuration-header',
  templateUrl: './configuration-header.component.html',
  styleUrls: ['./configuration-header.component.scss'],
})
export class ConfigurationHeaderComponent {
  @Input() title = '';
  @Input() description = '';
  @Input() hasDescriptionProjection = false;
  @Input() showSwitch = true;
  @Input() checked = false;
  @Input() disabled = false;
  @Input() hasPopover = false;

  @Output() changed = new EventEmitter<boolean>();

  switchChanged(value: boolean) {
    this.changed.emit(value);
  }
}
